/**
 * ## cortex:std:safeJsonParse
 * Returns a parsed JSON object or the inserted data.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function safeJsonParse<T>(data: any): T {
	try {
		return JSON.parse(data) as T;
	} catch (error) {
		return data;
	}
}
